"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringTableT = exports.StringTable = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
class StringTable {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsStringTable(bb, obj) {
        return (obj || new StringTable()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsStringTable(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new StringTable()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    s(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    static startStringTable(builder) {
        builder.startObject(1);
    }
    static addS(builder, sOffset) {
        builder.addFieldOffset(0, sOffset, 0);
    }
    static endStringTable(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createStringTable(builder, sOffset) {
        StringTable.startStringTable(builder);
        StringTable.addS(builder, sOffset);
        return StringTable.endStringTable(builder);
    }
    unpack() {
        return new StringTableT(this.s());
    }
    unpackTo(_o) {
        _o.s = this.s();
    }
}
exports.StringTable = StringTable;
class StringTableT {
    constructor(s = null) {
        this.s = s;
    }
    pack(builder) {
        const s = (this.s !== null ? builder.createString(this.s) : 0);
        return StringTable.createStringTable(builder, s);
    }
}
exports.StringTableT = StringTableT;
